import "../../Assets/Styles/Header.css";
import "../../Assets/Styles/Main.css";
import {useEffect, useState} from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import Header from "../../Layouts/Header/Header";
import Footer from "../../Layouts/Footer/Footer";
import {Carousel} from "../../Components/Carousel";
import {LinkButtons} from "../../Components/LinkButtons";
import {Trans, useTranslation} from "react-i18next";

export default function Main() {
    const {i18n} = useTranslation();

    const [matches, setMatches] = useState(window.matchMedia("(max-width: 1096px)").matches);
    const [bgMatches, setBgMatches] = useState(window.matchMedia("(max-width: 530px)").matches);
    const [didViewCountUp, setDidViewCountUp] = useState(false);

    useEffect(() => {
        window
            .matchMedia("(max-width: 1096px)")
            .addEventListener('change', e => setMatches(e.matches));

        window
            .matchMedia("(max-width: 530px)")
            .addEventListener('change', e => setBgMatches(e.matches));
    });

    const onVisibilityChange = isVisible => {
        if (isVisible) {
            setDidViewCountUp(true);
        }
    }

    return (
        <>
            <div className="first-container">
                <Header/>
                <div className="sect block-1">
                    <div className="block-1-sect">
                        <div className="block-1-heading">
                            {i18n.t("Find")} <span>{i18n.t("recycling")}</span> {i18n.t("boring?")}<br/> {i18n.t("Let`s do it with")} <span>{i18n.t("fun")}</span>.
                        </div>
                        {matches ?
                            <img className="block-1-img-mob" alt="bird-phone"
                                 src={require("../../Assets/Images/bird-phone-mob.svg").default}
                            />
                            :
                            <img className="block-1-img" alt="bird-phone"
                                 src={require("../../Assets/Images/bird-phone.svg").default}
                            />
                        }
                        <div className="block-1-text">
                            <span>FUN recycle</span> {i18n.t("is a mobile app that helps to track waste recycling and view statistics of the impact of recycling on the environment.")}
                        </div>
                        <LinkButtons/>
                    </div>
                    <div className="block-1-rating">
                        <div className="block-1-rating-item">
                            <div className="block-1-rating-count">4.8/5</div>
                            <div className="stars">
                                {[...Array(5)].map((star, index) => {
                                    index += 1;
                                    return (
                                        <img key={index} alt="star"
                                             src={require("../../Assets/Images/star.svg").default}
                                        />
                                    );
                                })}
                                {i18n.t("Rating")}
                            </div>
                        </div>
                        <div className="block-1-rating-item">
                            <div className="block-1-rating-count">
                                <img alt="avatars" className="block-1-rating-avatars"
                                     src={require("../../Assets/Images/avatars.svg").default}
                                />
                                <div>15K+</div>
                            </div>
                            <div className="stars">{i18n.t("Using application")}</div>
                        </div>
                    </div>
                </div>
                <div className="sect block-2">
                    <div className="block-sect">
                        {matches ? <p className="block-heading">{i18n.t("About Application")}</p> : null}
                        <img className="block-img"
                             alt="recycling_statistics"
                             src={require("../../Assets/Images/recycling_statistics.svg").default}/>
                        <div className="block-about">
                            {!matches ? <p className="block-heading">{i18n.t("About Application")}</p> : null}
                            <p className="block-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            </p>
                            <div className="block-2-items">
                                <div>
                                    <p>Lorem ipsum</p>
                                    <p>Dolor sit amet</p>
                                </div>
                                <div>
                                    <p>Consectetur adipiscing </p>
                                    <p>Sed do eiusmod</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="block-2-counter">
                        <div className="counter-block">
                            <div className="counter-item">
                                <VisibilitySensor onChange={onVisibilityChange} delayedCall offset={{
                                    top:
                                        10
                                }}>
                                    <CountUp className="counter-number"
                                             start={0} end={didViewCountUp ? 10000 : 0} suffix="+"
                                    />
                                </VisibilitySensor>
                                <p className="counter-text">{i18n.t("App download")}</p>
                            </div>
                            <div className="counter-item">
                                <VisibilitySensor onChange={onVisibilityChange} delayedCall offset={{
                                    top:
                                        10
                                }}>
                                    <CountUp className="counter-number"
                                             start={0} end={didViewCountUp ? 3000 : 0} suffix="+"
                                    />
                                </VisibilitySensor>
                                <p className="counter-text">{i18n.t("Active User")}</p>
                            </div>
                        </div>
                        <div className="counter-block">
                            <div className="counter-item">
                                <VisibilitySensor onChange={onVisibilityChange} delayedCall offset={{
                                    top:
                                        10
                                }}>
                                    <CountUp className="counter-number"
                                             start={0} end={didViewCountUp ? 763 : 0} suffix="+"
                                    />
                                </VisibilitySensor>
                                <p className="counter-text">{i18n.t("Reviews")}</p>
                            </div>
                            <div className="counter-item">
                                <VisibilitySensor onChange={onVisibilityChange} delayedCall offset={{
                                    top:
                                        10
                                }}>
                                    <CountUp className="counter-number"
                                             start={0} end={didViewCountUp ? 568 : 0} suffix="+"
                                    />
                                </VisibilitySensor>
                                <p className="counter-text">{i18n.t("Reviews")}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {bgMatches ?
                    <img className="container-bg" alt="bg"
                         src={require("../../Assets/Images/Bg-mobile.png")}
                    />
                    :
                    <img className="container-bg" alt="bg"
                         src={require("../../Assets/Images/Bg.png")}
                    />
                }
                <img className="feather" alt="feather"
                     src={require("../../Assets/Images/Feather.svg").default}
                />
                <img className="tree" alt="tree"
                     src={require("../../Assets/Images/Tree.svg").default}
                />
            </div>
            <div className="second-container">
                <div className="sect block-3">
                    <div className="block-heading">{i18n.t("Key features")}</div>
                    <img className="block-3-img" alt="block-3-img"
                         src={require("../../Assets/Images/block-3-img.svg").default}
                    />
                    <div className="block-3-items">
                        <div className="block-3-items-sect">
                            <div className="block-3-item">
                                <p className="block-3-item-heading">{i18n.t("Dashboard")}</p>
                                <p className="block-3-item-text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                            <div className="block-3-item">
                                <p className="block-3-item-heading">{i18n.t("Statistics")}</p>
                                <p className="block-3-item-text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                            <div className="block-3-item">
                                <p className="block-3-item-heading">{i18n.t("Recycling")}</p>
                                <p className="block-3-item-text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                        </div>
                        <div className="block-3-items-sect">
                            <div className="block-3-item">
                                <p className="block-3-item-heading">{i18n.t("User friendly")}</p>
                                <p className="block-3-item-text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                            <div className="block-3-item">
                                <p className="block-3-item-heading">{i18n.t("Achievements")}</p>
                                <p className="block-3-item-text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                            <div className="block-3-item">
                                <p className="block-3-item-heading">Lorem Ipsum</p>
                                <p className="block-3-item-text">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sect block-4">
                    <div className="block-heading">{i18n.t("Users feedback")}</div>
                    <Carousel/>
                </div>
                <div className="sect block-5">
                    <div className="block-sect block-5-sect">
                        {matches ? <p className="block-heading">{i18n.t("Download App")}</p> : null}
                        <img className="block-img"
                             alt="block-5-img"
                             src={require("../../Assets/Images/block-5-img.svg").default}
                        />
                        <div className="block-about">
                            {!matches ? <p className="block-heading">{i18n.t("Download App")}</p> : null}
                            <p className="block-text">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            </p>
                            <LinkButtons/>
                        </div>
                    </div>
                </div>
                <Footer/>
                {bgMatches ?
                    <img className="container-bg" alt="bg"
                         src={require("../../Assets/Images/mountains-mobile-bg.svg").default}
                    />
                    :
                    <img className="container-bg" alt="bg"
                         src={require("../../Assets/Images/mountains-bg.svg").default}
                    />
                }
            </div>
        </>
    );
}